'use client';

import { JSX, useEffect, useState } from 'react';
import { Typography } from '@/components/atoms/Typography/Typography';
import { ISelectedFilters, useFiltersStore } from '@/store/useFiltersStore';
import { TWorkPageType } from '@/types/global';
import * as Styled from './InfoResults.styled';


interface IInfoResults {
  isDisplayed: boolean;
  workPageType: TWorkPageType;
  className?: string;
}

/** Displays the number of projects found with the current filters
 * @param  {IInfoResults} props - The component props
 * @returns {JSX.Element}       - The InfoResults component
 */
export function InfoResults({
  workPageType,
  className,
}: IInfoResults): JSX.Element {

  const [projectsNumber, setProjectsNumber] = useState<number>(0);

  const imagesWithProjects = useFiltersStore(
    (state) => state.imagesWithProjects
  );

  const imageSearch = useFiltersStore(
    (state) => state.imageSearch
  );

  const projectsIDs = useFiltersStore(
    (state) => state.projectsIDs
  );

  const isCurrentlyFetchingProjects = useFiltersStore(
    (state) => state.isCurrentlyFetchingProjects
  );

  useEffect(() => {
    if (imageSearch.value) {
      setProjectsNumber(imagesWithProjects?.length || 0);
      return;
    }
    setProjectsNumber(
      (projectsIDs?.archived?.length ?? 0) + (projectsIDs?.notArchived?.length ?? 0)
    );
  }, [projectsIDs, imagesWithProjects, imageSearch]);

  const getTextDisplayed = () => {
    // Case initial list 
    // if (firstFetchFilteredProjects === undefined && !imageSearch.value) {
    //   return 'initial';
    // }
    const selectedFilters: ISelectedFilters = useFiltersStore.getState().selectedFilters;
    const search = useFiltersStore.getState().search;
    const searchImage = useFiltersStore.getState().imageSearch;
    // This is the case for main work page, showing several lists of projects:
    if (workPageType === 'work' && (((!selectedFilters?.filters) || selectedFilters?.filters?.length === 0 && !search?.value && !searchImage?.value))) {
      return 'none';
    }
    return 'filtered';
  };

  return (
    <Styled.InfoResultsContainer
      data-is-loading={isCurrentlyFetchingProjects}
      data-work-page-type={workPageType}
      className={`info-results-container ${className || ''}`}
      data-text-displayed={getTextDisplayed()}
    >
      <Typography
        text={{
          en: `We have found <span style="color: var(--c-font-primary);"><span class="number">${projectsNumber}</span> ${!imageSearch.value ? 'projects' : 'assets'}</span>  with these criteria`,
          es: `Hemos encontrado <span style="color: var(--c-font-primary);"><span class="number">${projectsNumber}</span> ${!imageSearch.value ? 'proyectos' : 'recursos'}</span>  con estos criterios`,
        }}
        color="secondary"
        className="results-text"
      />
    </Styled.InfoResultsContainer>
  );
}
